<template>
  <div
    v-if="isApplyingBulk"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/35 px-6 backdrop-blur-[2px]"
    role="status"
    aria-live="polite"
    aria-label="Gegevens worden gesynchroniseerd"
  >
    <div class="surface w-full max-w-sm rounded-2xl px-6 py-5 shadow-xl">
      <div class="flex items-center gap-3">
        <FontAwesomeIcon
          :icon="['fas', 'arrows-rotate']"
          class="text-primary animate-spin"
          aria-hidden="true"
        />
        <p class="font-semibold">Gegevens worden gesynchroniseerd</p>
      </div>
      <p v-if="hasProgress" class="mt-2 text-sm opacity-70">
        {{ bulkProgress.processed }} van {{ bulkProgress.total }} berichten verwerkt ({{
          progressPercentage
        }}%)
      </p>
      <p v-else class="mt-2 text-sm opacity-70">Berichten worden verwerkt</p>
      <!-- Centrifugo reports that recovered publications are pending, but not how many, so the bar
           runs indeterminate unless a caller supplied a real total. -->
      <div
        v-if="hasProgress"
        class="mt-4 h-1.5 overflow-hidden rounded-full bg-gray-200/60 dark:bg-gray-700/60"
        role="progressbar"
        :aria-valuenow="progressPercentage"
        aria-valuemin="0"
        aria-valuemax="100"
        :aria-label="`${progressPercentage}% voltooid`"
      >
        <div
          class="bg-primary h-full rounded-full transition-[width] duration-100"
          :style="{ width: `${progressPercentage}%` }"
        ></div>
      </div>
      <div
        v-else
        class="mt-4 h-1.5 overflow-hidden rounded-full bg-gray-200/60 dark:bg-gray-700/60"
        role="progressbar"
        aria-label="Bezig met synchroniseren"
      >
        <div class="bg-primary h-full w-1/3 animate-pulse rounded-full"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { storeToRefs } from "pinia"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { useSynchronisationStore } from "@/store/synchronisation.store"

const { isApplyingBulk, bulkProgress } = storeToRefs(useSynchronisationStore())

const hasProgress = computed(() => bulkProgress.value.total > 0)

const progressPercentage = computed(() => {
  if (bulkProgress.value.total === 0) {
    return 0
  }
  return Math.round((bulkProgress.value.processed / bulkProgress.value.total) * 100)
})
</script>
